<template>
  <div class="shareBox">
    分享到：
    <span class="hover-pointer" @click="shareToMicroblog()">
        微博
      <!-- <img src="@/assets/img/weibo.png" alt="" /> -->
    </span>
    <span class="qqIcon hover-pointer" @click="shareToQQRom()">
      qq
      <!-- <img src="@/assets/img/QQKJ.png" alt="" /> -->
    </span>
    <span class="hover-pointer" @click="shareToWeChat()">
      微信
      <!-- <img src="@/assets/img/weixin.png" alt="" /> -->
    </span>
  </div>
</template>
 
<script>
export default {
  props: ["sysInfo"],  //父组件传过来的文章数据
  data() {
    return {
      shareUrl: location.href,
    };
  },
  methods: {
    /**
     * 分享到微博
     */
    shareToMicroblog() {
      //跳转地址
      window.open(
        "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(this.shareUrl) +
          "&title=" +
          // this.sysInfo
          'qw'
      );
    },
    /**
     * 分享到qq空间
     */
    shareToQQRom() {
      //跳转地址
      window.open(
        "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
          encodeURIComponent(this.shareUrl) +
          "&title=" +
          this.sysInfo +
          "&summary=" +
          this.sysInfo
      );
    },
    /**
     * 分享到微信：需要单独画页面
     */
    shareToWeChat() {
      localStorage.setItem("shareUrl", this.shareUrl); // 存储当前页面地址，前端页面直接根据URL链接生成二维码
        let page = this.$router.resolve({
        name: 'mine',
        // query: { newId: newId },
      });
      window.open(page.href, '_blank');
      // let url = location.href.split("#") + "/mine"; // 注意：#/Share/toWechat: 自己定义的路由
      // window.open(url);
    },
  },
};
</script>
 
<style lang="less" scoped>
.shareBox {
  .iconfont {
    font-size: 22px !important;
  }
  .qqIcon {
    display: inline-block;
    margin: 0 10px;
  }
}
</style>